<template>
    <ul class="tag-class-wrap">
        <li v-for="item in data" :key="item.id" class="tag-item" :class="[selectId == item.id ? 'active' : '']" @click="tagClick(item)">
            <div class="tag-title">
                <span class="name">{{ item.name }}</span>
                <span class="id">{{ $i18n.t("zhiji.portrait.typeId") }}：{{ item.id }}</span>
            </div>
            <p class="tag-desc">{{ item.describe }}</p>
            <div class="tag-btn" @click.stop>
                <TagEdit :data="{ type: 'edit', tagData: item }" @submit="submitClick">
                    <el-button slot="dialogBtn" size="mini" icon="el-icon-edit" />
                </TagEdit>
                <el-button size="mini" icon="el-icon-delete" @click="deleteClick(item)" />
            </div>
        </li>
    </ul>
</template>

<script>
import TagEdit from "./TagEdit.vue";
import { deleteClass } from "../../service";

export default {
    name: "TagList",
    components: {
        TagEdit
    },
    props: {
        data: {
            type: Array,
            default() {
                return [];
            }
        },
        selectId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    methods: {
        tagClick(data) {
            this.$emit("click", data);
        },
        submitClick() {
            this.$emit("change");
        },
        deleteClick(data) {
            this.$confirm(this.$i18n.t("zhiji.portrait.delClassifyTip"), this.$i18n.t("zhiji.common.tips"), {
                confirmButtonText: this.$i18n.t("zhiji.common.confirm"),
                cancelButtonText: this.$i18n.t("zhiji.common.cancel"),
                type: "warning"
            }).then(() => {
                deleteClass({ id: data.id }).then(() => {
                    this.$emit("change");
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.tag-class-wrap {
    .tag-item {
        padding: 15px 16px;
        position: relative;
        &:hover {
            background: rgba(217, 235, 246, 0.7);
            cursor: pointer;
            .tag-btn {
                display: flex;
            }
        }
        .tag-title {
            display: flex;
            justify-content: space-between;
            margin-bottom: 6px;
            .name {
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .id {
                color: #9b9ba3;
                flex-shrink: 0;
                flex-grow: 0;
            }
        }
        .tag-desc {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .tag-btn {
            display: none;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 110px;
            height: 100%;
            right: 0;
            top: 0;
            background: #fbfbff;
            /deep/.el-button {
                border: none;
                background: transparent;
            }
        }
    }
    .active {
        background: rgba(217, 235, 246, 0.7);
    }
}
</style>
